// import { Code } from '@mantine/core';
import ErrorPageGeneral from '@components/error-page-general';
import * as Sentry from '@sentry/browser';

function DataError({ error = new Error('Unknown Data Error') }: { error: Error }) {
  // eslint-disable-next-line no-console
  // console.error('Data Error: ', error);
  Sentry.captureException(error, { extra: { error } });

  // TODO: make modal or similar
  return (
    <ErrorPageGeneral error={error} />
    // <Code block>
    //   ERROR:{'\n'}
    //   {error ? JSON.stringify(error, null, 2) : 'Undefined Error!!'}
    // </Code>
  );
}

export default DataError;
